import {
  User,
  UserDashboard,
  UserOrder,
  UserOrderList,
  UserBooking,
  UserProfile,
  UserInvoice,
  UserEvents,
  UserEventsList,
  UserEventsView,
  UserProfileModalEdit,
  UserCheckout
} from "@/modules/user";

import NewBooking from "@/components/booking/NewBooking";

export default [
  {
    path: "/user",
    name: "user",
    component: User,
    meta: {
      isAuthorized: true,
      isMember: true
    },
    redirect: "/user/dashboard",
    children: [
      {
        path: "dashboard",
        name: "UserDashboard",
        component: UserDashboard
      },
      {
        path: "events",
        name: "",
        component: UserEvents,
        children: [
          {
            path: "",
            name: "eventsList",
            component: UserEventsList
          },
          {
            path: ":id",
            name: "viewEvent",
            component: UserEventsView
          }
        ]
      },
      {
        path: "orders",
        name: "UserOrder",
        component: UserOrder,
        redirect: "/user/orders/list",
        children: [
          {
            path: "list",
            name: "UserOrderList",
            component: UserOrderList
          },
          {
            path: "past-order",
            name: "UserOrderBooking",
            component: UserBooking
          },
          {
            path: "invoice/:invoiceId",
            name: "user-invoice",
            component: UserInvoice
          },
          {
            path: "new-order/:categoryId",
            name: "UserBookingReform",
            redirect: { name: "UserBookingV3" },
            component: NewBooking
          },
          {
            path: "order-v3",
            name: "UserBookingV3",
            component: NewBooking
          }
        ]
      },
      {
        path: "checkout",
        name: "UserCheckout",
        component: UserCheckout
      },
      {
        path: "profile",
        name: "profile",
        component: UserProfile,
        children: [
          {
            path: "edit-profile",
            name: "UserProfileModalEdit",
            component: UserProfileModalEdit
          }
        ]
      }
    ]
  }
];
